export default __webpack_public_path__ + "static/media/buyUpChecked.3a2a7f48.svg";